__turbopack_context__.v({
  "hoverContainer": "Header14-module___Uatba__hoverContainer",
  "logo": "Header14-module___Uatba__logo",
  "memberMenu": "Header14-module___Uatba__memberMenu",
  "orderMenuContent": "Header14-module___Uatba__orderMenuContent",
  "orderMenuLink": "Header14-module___Uatba__orderMenuLink",
  "orderMessageBadge": "Header14-module___Uatba__orderMessageBadge",
  "orderMessageMenuBadge": "Header14-module___Uatba__orderMessageMenuBadge",
});
